import PropTypes from 'prop-types';
import { PROJECT_VIEW_MODES } from 'utils/constants';

export const ViewModesPropType = PropTypes.oneOf(Object.values(PROJECT_VIEW_MODES));
